import styled from '@emotion/styled';
import { ui } from '@libs/domain';
import { useItemNames } from '@ps-smart-cp/ppfw-client';
import { type ChangeEvent, useState } from 'react';
import { useNavigate } from 'react-router';
import {
  Body,
  LoginContainer,
  LoginInputField,
  StyledLoginButton,
  StyledLoginLink,
  fetchSsoStatus,
} from '../features/login';
import { useTryShell } from '../hooks';

const LogoLink = styled.a`
  align-self: flex-start;
`;

const CompanyLogo = styled.img`
  width: 200px;
  height: auto;
`;

const Copyright = styled.footer`
  margin: 0 5px 5px 0;
  align-self: flex-end;
  font-size: 12px;
  color: #666;
`;

export function TopPage() {
  const navigate = useNavigate();
  const { tryRequest, error, setError } = useTryShell();

  const [organizationId, setOrganizationId] = useState('');

  const titleNames = useItemNames(ui.titleNames);
  const labelNames = useItemNames(ui.labelNames);
  const linkNames = useItemNames(ui.linkNames);
  const buttonNames = useItemNames(ui.buttonNames);

  // AUTH-333 エラーメッセージのローカライズ
  const onNext = async () =>
    await tryRequest(async () => {
      if (organizationId === '') {
        setError('【ログインエラー】組織IDを入力してください。(EFW56013)');
        return;
      }

      const res = await fetchSsoStatus(organizationId);

      navigate(`/login?id=${organizationId.trim()}`, {
        state: {
          organizationName: res.organizationName,
          ssoStatus: res.ssoStatus,
        },
      });
    });

  return (
    <Body>
      <LogoLink href="https://www.proship.co.jp/" target="_blank">
        <CompanyLogo src="images/pslogo.png" alt="ProShip" />
      </LogoLink>
      <LoginContainer title={titleNames('login')} error={error}>
        <LoginInputField
          id="organization-id"
          label={`${labelNames('organizationId')}*`}
          value={organizationId}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setOrganizationId(e.target.value)}
          onEnter={onNext}
        />
        <StyledLoginButton id="next-btn" displayName={buttonNames('toNext')} onClick={onNext} />
        <StyledLoginLink id="admin-here" to="/admin-login" displayName={linkNames('adminHere')} />
      </LoginContainer>

      <Copyright>Copyright &copy; 2024 Pro-Ship Incorporated. All right reserved.</Copyright>
    </Body>
  );
}
